export default __webpack_public_path__ + "static/media/icon1.6e23e5a1.jpg";